/*@flow*/
import type { Node } from 'react';
import { createElement } from 'react';
import nested from 'lib/nested';
import type { ComponentPropsT } from '../types';
import getTemplate from '../util/getTemplate';
import getTransformer from '../util/getTransformer';
import { useLocals, useField, useStructInputs } from '../hooks';

export default function StructComponent(props: ComponentPropsT): Node {
  const { path } = props;
  const { fieldOptions, typeInfo } = useField(path);
  const inputs = useStructInputs(path);
  const transformer = getTransformer(fieldOptions, 'struct');
  const locals = useLocals(path, { transformer });
  const typeProps = nested<{}>(typeInfo, 'innerType.meta.props', {});
  const order = fieldOptions.order || Object.keys(typeProps);
  const template = getTemplate(fieldOptions, 'struct');

  return createElement(template, {
    ...locals,
    inputs,
    order,
  });
}
